import { render, staticRenderFns } from "./marketNews.vue?vue&type=template&id=56ca6514&scoped=true&"
import script from "./marketNews.vue?vue&type=script&lang=js&"
export * from "./marketNews.vue?vue&type=script&lang=js&"
import style0 from "./marketNews.vue?vue&type=style&index=0&id=56ca6514&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ca6514",
  null
  
)

export default component.exports